import React, { useState } from 'react';
import { Helmet } from 'react-helmet';

import { Link } from 'inside-out/components/shared/link';
import { Cards } from 'inside-out/components/shared/cards';
import { ResourceCard } from 'inside-out/components/shared/cards/resourceCard';

import { MedicareForHealthProfessionalsStep1Page } from 'inside-out/components/medicare/for-health-professionals/step-1';
import { MedicareForHealthProfessionalsStep2Page } from 'inside-out/components/medicare/for-health-professionals/step-2';
import { MedicareForHealthProfessionalsStep3Page } from 'inside-out/components/medicare/for-health-professionals/step-3';
import { MedicareForHealthProfessionalsStep4Page } from 'inside-out/components/medicare/for-health-professionals/step-4';
import { MedicareForHealthProfessionalsStep5Page } from 'inside-out/components/medicare/for-health-professionals/step-5';
import { MedicarePreparingYourPracticePage } from 'inside-out/components/medicare/for-health-professionals/preparing-your-practice';

import { StepSelect } from 'inside-out/components/medicare/stepSelect'
import FAQImg from 'inside-out/images/medicare/faq.png';

import {
	innerWrapperStyle,
	titleStyle,
	textStyle,
  cardsStyle,
  ctaStyle,
  videoSection,
  videoDiv,
} from 'inside-out/page-styles/medicare';

import {
  blue,
  purple,
  lightGrey,
	contentSection,
	tabletPortraitMaxWidthBreakpoint,
} from 'inside-out/global-styles';

import { stepCardStyle } from 'inside-out/components/medicare/stepSelect/styles'

import MyselfBG from 'inside-out/images/register/myself-bg.svg';
import HealthProfessionalBG from 'inside-out/images/register/health-professional-bg.svg';

function MedicareForHealthProfessionalsPage() {
  const [ step, setStep ] = useState(0)
  const [ preparing, setPreparing ] = useState(false)

  return (<React.Fragment>
      <Helmet title="Medicare for Health Professionals">
        <meta property="og:type" content="website"/>
        <meta property="og:title" content="Medicare for Health Professionals"/>
        <meta name="description" content="Medicare for Health Professionals" />
        <meta property="og:description" content="Medicare for Health Professionals" />
      </Helmet>

      <section className={contentSection('#fff')}>
        <div className={innerWrapperStyle}>
          <h1 className={titleStyle} style={{color: blue}}>Medicare for Health Professionals</h1>
				  <div className={textStyle}>
				  	<p><a rel="noopener noreferrer" target="_blank" href="https://insideoutinstitute.org.au/resource-library/medicare-clinician-faqs"><img src={ FAQImg } alt="FAQ link" /></a>.</p>
          </div>
        </div>
      </section>

      <section className={videoSection(blue)}>
        <div className={videoDiv}>
          <div>How does it work?</div>

          <iframe src="https://player.vimeo.com/video/369493029" width="640" height="360" frameBorder="0" allow="autoplay; fullscreen" allowFullScreen></iframe>

          <div style={{width: '250px', position: 'absolute' }}>
            <ResourceCard
              background={ null }
              to={ '/resource-library/mbs-eating-disorder-items' }
              audiences={ [] }
              title={ 'Medicare Items Summary' }
              body={ 'Medicare item numbers for the suite of new items.' }
              date={ '1 Nov, 2019' }
            />
          </div>
        </div>
      </section>

      <StepSelect step={step} setStep={setStep} color={ blue } />

      { (step === 1) && <MedicareForHealthProfessionalsStep1Page /> }
      { (step === 2) && <MedicareForHealthProfessionalsStep2Page /> }
      { (step === 3) && <MedicareForHealthProfessionalsStep3Page /> }
      { (step === 4) && <MedicareForHealthProfessionalsStep4Page /> }
      { (step === 5) && <MedicareForHealthProfessionalsStep5Page /> }

      <section className={contentSection('#FFF')}>
        <div className={innerWrapperStyle} style={{overflowX: 'visible'}}>
          <div onClick={ () => setPreparing(!preparing) } style={{background: preparing && purple || lightGrey, width: '400px'}} className={ stepCardStyle }>
            Get Training
          </div>
        </div>
      </section>

      { (preparing) && <MedicarePreparingYourPracticePage /> }
  </React.Fragment>)
}

export default MedicareForHealthProfessionalsPage



// WEBPACK FOOTER //
// ./src/pages/medicare/for-health-professionals/index.js